export const LOGOUT_REASONS = Object.freeze({
  ADMIN_LOGOUT: 'admin_logout',
  INACTIVITY_TIMEOUT: 'inactivity_timeout',
  SESSION_REPLACED: 'session_replaced',
});

export const logoutReasonLabels = {
  [LOGOUT_REASONS.SESSION_REPLACED]: 'Login em outro dispositivo',
  [LOGOUT_REASONS.ADMIN_LOGOUT]: 'Por um gestor da conta',
  [LOGOUT_REASONS.INACTIVITY_TIMEOUT]: 'Por inatividade',
};

export function getLogoutReasonLabel(reason) {
  return logoutReasonLabels[reason] || reason;
}
